'use client'
import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { useState } from 'react';
import ServiceDetailsImg from '../../assets/images/services/security.png'
import ServiceDetailsImg1 from '../../assets/images/services/deisgn-implementation-1.jpg'
import ServiceDetailsImg2 from '../../assets/images/services/deisgn-implementation-2.jpg'

const SkylineMain = () => {
    // State to hold dynamic content
    const [serviceDetails] = useState({
        title: "Offensive Security, Red Teaming",
        text1: "Creating content on offensive security and red teaming involves exploring the proactive side of cybersecurity, where organizations simulate attacks to identify vulnerabilities and strengthen their defenses. Here are content ideas and basic steps to help you develop informative material:",
        image1: ServiceDetailsImg,
        text2: (
        <>
        <b>What is Offensive Security and Red Teaming?:</b><br />
        Offensive Security: Ethical hacking techniques that simulate real-world attacker tactics.<br />
        <br />
        <b>Red Teaming:</b><br />
        A simulated attack conducted by security professionals to identify and exploit weaknesses in your defenses.<br />
        <br />
        <b>Why Choose Red Teaming?:</b><br />
        Test your organization’s readiness and response to cyber threats.<br />
        Prioritize security investments by identifying critical vulnerabilities.<br />
        Enhance security protocols and staff awareness.<br />
        <br />
        <b>Our Red Teaming Process:</b><br />
        1. Planning: Define objectives and rules of engagement.<br />
        2. Reconnaissance: Gather intelligence on target systems.<br />
        3. Attack Simulation: Launch realistic attacks to expose weaknesses.<br />
        4. Reporting: Document findings and provide actionable recommendations.<br />
        <br />
        </>
        ), 
        images: [ ServiceDetailsImg1, ServiceDetailsImg2
        ],
        features: [
            {
                icon: "icon-crane-1",
                title: "Reliable Roof Repair",
                text: "Roof service involves the installation, maintenance, and repair of roofs for the commercial",
                link: "#",
            },
            {
                icon: "icon-buildings",
                title: "Building Roof Repair",
                text: "Roof service involves the installation, maintenance, and repair of roofs for the commercial",
                link: "#",
            },
        ],
    });

    return (
        <React.Fragment>
            {/* Service Details Start */}
            <section className="service-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__left">
                                <div className="service-details__content-one">
                                    <h2 className="service-details__title-one">{serviceDetails.title}</h2>
                                    <p className="service-details__text-1">{serviceDetails.text1}</p>
                                    <div className="service-details__img-one">
                                        <img src={serviceDetails.image1} alt="" />
                                    </div>
                                </div>
                                <div className="service-details__content-two">
                                    <h4 className="service-details__title-two">{serviceDetails.title2}</h4>
                                    <p className="service-details__text-2">{serviceDetails.text2}</p>
                                    <h4 className="service-details__title-two">{serviceDetails.title3}</h4>
                                    <p className="service-details__text-2">{serviceDetails.text3}</p>
                                    <h4 className="service-details__title-two">{serviceDetails.title4}</h4>
                                    <p className="service-details__text-2">{serviceDetails.text4}</p>
                                    <p className="service-details__text-2">{serviceDetails.text5}</p>
                                    <p className="service-details__text-2">{serviceDetails.text6}</p>
                                    <h4 className="service-details__title-two">{serviceDetails.title5}</h4>
                                    <p className="service-details__text-2">{serviceDetails.text7}</p>
                                    <p className="service-details__text-2">{serviceDetails.text8}</p>
                                    <p className="service-details__text-2">{serviceDetails.text9}</p>
                                    <p className="service-details__text-2">{serviceDetails.text10}</p>
                                
                                </div>
                                <div className="service-details__images-box">
                                    <div className="row">
                                        {serviceDetails.images.map((image, index) => (
                                            <div key={index} className="col-xl-6 col-lg-6">
                                                <div className="service-details__images-single">
                                                    <img src={image} alt="" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5">
                            <div className="service-details__sidebar">
                                <div className="service-details__service-list-box">
                                <h4 className="service-details__sidebar-title">Main Service</h4>
                                <ul className="service-details__service-list list-unstyled">
                                    <li>
                                    <Link to="/security-consulting">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Security Consulting
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/audit-&-compliance">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Audit & Compliance
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/cloud-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Cloud Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/network-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Network Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/design-&-implementation">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Design & Implementation
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/managed-it-services">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Managed IT Services
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/ot-iot-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        OT, IoT Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/api-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        API Security
                                    </Link>
                                    </li>
                                    <li className="active">
                                    <Link to="/offensive-security-red-teaming">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Offensive Security, Red Teaming
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/vulnerability-assessment">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Vulnerability Assessment
                                    </Link>
                                    </li>                                                               </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Service Details End */}
        </React.Fragment>
    );
};

export default SkylineMain;
